var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "price-adjust-modal" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品调价",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "destroy-on-close": "",
            width: "800px",
            "custom-class": "price-adjust-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.submitLoading },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("提 交")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "tips-section" }, [
            _c("p", [
              _vm._v(
                "商品批量调价：勾选的商品，进行批量修改价格，支持取竞品不同的价格进行调整"
              ),
            ]),
            _c("p", { staticClass: "indent" }, [
              _vm._v("提交的调价单，在商品调价管理查询"),
            ]),
            _c("p", { staticClass: "indent" }, [
              _vm._v("调价单审核，在商品调价审核功能进行审核管理"),
            ]),
          ]),
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "90px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "调价取值：",
                    prop: "adjustTakePriceType",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formData.adjustTakePriceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "adjustTakePriceType", $$v)
                        },
                        expression: "formData.adjustTakePriceType",
                      },
                    },
                    _vm._l(_vm.priceSourceOptions, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(" " + _vm._s(item.label) + " ")]
                      )
                    }),
                    1
                  ),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("当前平台竞品产品为 京东和淘宝两家"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "调价原因：", prop: "adjustReason" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "280px" },
                      attrs: { placeholder: "- 请选择 -" },
                      model: {
                        value: _vm.formData.adjustReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "adjustReason", $$v)
                        },
                        expression: "formData.adjustReason",
                      },
                    },
                    _vm._l(_vm.adjustReasonOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息：", prop: "remark" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入备注信息",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }